import { GetterTree } from "vuex";

import RootState from "../../root-state";
import State from "./state";

// GetterTree<[current state], [root state]>
const getters: GetterTree<State, RootState> = {};

export default getters;
